
import { Component, Prop, Vue } from 'vue-property-decorator'
import User from '@/models/User'

@Component
export default class ExactAuthorizationDialog extends Vue {
	@Prop({
		type: Boolean,
		required: true,
		default: false
	})
	opened!: boolean

	@Prop({ required: false, default: null })
	label!: string | null

	user: User | null = null

	get authorizationUrl() {
		return `${User.baseUrl()}accounting/exact-online/connect/${this.user?.getApiId()}`
	}

	async created() {
		this.user = await User.fetchMeLazy()
	}
}
